/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ETAPA_CASO (state, item) {
    state.etapas_caso.unshift(item)
  },
  SET_ETAPA_CASO (state, etapas_caso) {
    state.etapas_caso = etapas_caso
    state.meta.push(etapas_caso.meta)
  },
  UPDATE_ETAPA_CASO (state, etapa_caso) {
    const productIndex = state.etapas_caso.findIndex((p) => p.id === etapa_caso.id)
    Object.assign(state.etapas_caso[productIndex], etapa_caso)
  },
  REMOVE_ETAPA_CASO (state, itemId) {
    const ItemIndex = state.etapas_caso.findIndex((p) => p.id === itemId)
    state.etapas_caso.splice(ItemIndex, 1)
  },
  SET_CODIGO_GRUPO (state, codigoGrupo) {
    state.codigo_grupo = codigoGrupo
  }
}
